import React, { useCallback, useEffect } from "react";
import { actions as alertActions, selectors as alertSelectors } from "@containers/Alert/store";
import { actions as sharedActions } from "@shared/store";
import { AlertNotificationList } from "@containers/Alert/components";
import { useDispatch, useSelector } from "react-redux";
import { AlertNotification, Patient } from "@shared/models";
import { MODAL_TYPES, SENSOR_SIGNAL_TYPE } from "@shared/constants";

interface AlertListContainerProps {
  patient?: Patient;
  hospitalId?: number;
  signalType?: SENSOR_SIGNAL_TYPE;

  onRowClick?: (item: AlertNotification) => void;
  onClose: () => void;
}

const AlertListContainer = (props: AlertListContainerProps) => {
  const dispatch = useDispatch();
  const { patient, onClose, hospitalId, signalType, onRowClick } = props;

  const filter = useSelector(alertSelectors.getFilter());
  const alertNotifications = useSelector(alertSelectors.getAlertNotifications());
  const alertNotificationsTotal = useSelector(alertSelectors.getAlertNotificationsTotal());

  const loadNextPage = useCallback(() => {
    if (filter.limit * (filter.page + 1) < alertNotificationsTotal) {
      dispatch(
        alertActions.setFilter({
          ...filter,
          page: filter.page + 1,
        }),
      );
    }
  }, [dispatch, filter, alertNotificationsTotal]);

  const onClickMarkAsRead = useCallback(
    (alertNotification: AlertNotification) => {
      dispatch(
        sharedActions.showModal({
          type: MODAL_TYPES.ALERT_READ_CONFIRM,
          props: {
            alertNotification,
            patientSettings: patient?.patient_settings,
            onSuccess: (comment: string) => {
              dispatch(
                alertActions.readAlertNotification.request({
                  id: alertNotification.id,
                  comment,
                }),
              );
            },
          },
        }),
      );
    },
    [dispatch, patient],
  );

  useEffect(() => {
    dispatch(
      alertActions.getAlertNotifications.request({
        ...filter,
        hospital_id: hospitalId,
        signal_type: signalType,
        patient_id: patient?.id,
        unread: true,
      }),
    );
  }, [dispatch, patient?.id, hospitalId, signalType, filter]);

  useEffect(() => {
    return () => {
      dispatch(alertActions.setFilter(null));
    };
  }, [dispatch]);

  return (
    <div className="alert-notifications-list-container">
      <AlertNotificationList
        alertNotifications={alertNotifications}
        loadNextPage={loadNextPage}
        title="Notifications"
        onClose={onClose}
        patientSettings={patient?.patient_settings}
        onClickMarkAsRead={patient ? onClickMarkAsRead : undefined}
        onRowClick={!patient ? onRowClick : undefined}
      />
    </div>
  );
};

export default AlertListContainer;
